export default __webpack_public_path__ + "static/media/gallery_02.c9855d96.jpg";